module.exports = __webpack_public_path__ + "img/4af25f9.png";